import type {
  AppCreatedResponse,
  AppInstallSummary,
  AppSummary,
  CreateAppRequest,
  LoginRequest,
  PartnerLoginResponse,
  PartnerUser,
  ThemeSummary,
  UpdateAppRequest,
} from '@upweo/types';

import { apiRequest } from './api-client.js';

export const login = (body: LoginRequest): Promise<PartnerLoginResponse> =>
  apiRequest<PartnerLoginResponse>('/auth/login', { method: 'POST', body });

export const logout = (): Promise<{ success: boolean }> =>
  apiRequest<{ success: boolean }>('/auth/logout', { method: 'POST' });

export const me = (): Promise<{ user: PartnerUser }> =>
  apiRequest<{ user: PartnerUser }>('/auth/me');

export const listApps = (): Promise<readonly AppSummary[]> =>
  apiRequest<readonly AppSummary[]>('/apps');

/** The only response that ever carries the plaintext client secret. */
export const createApp = (body: CreateAppRequest): Promise<AppCreatedResponse> =>
  apiRequest<AppCreatedResponse>('/apps', { method: 'POST', body });

export const updateApp = (id: string, body: UpdateAppRequest): Promise<AppSummary> =>
  apiRequest<AppSummary>(`/apps/${id}`, { method: 'PATCH', body });

export const listInstalls = (): Promise<readonly AppInstallSummary[]> =>
  apiRequest<readonly AppInstallSummary[]>('/installs');

export const listThemes = (): Promise<readonly ThemeSummary[]> =>
  apiRequest<readonly ThemeSummary[]>('/themes');

export const formatDate = (iso: string): string =>
  new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(new Date(iso));

export const formatMoney = (amount: string, currencyCode = 'USD'): string =>
  new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(
    Number(amount),
  );
